import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type InAppNoticeService from "cc-frontend/services/in-app-notice"

export default class InAppNoticeComponent extends Component {
  @service declare inAppNotice: InAppNoticeService

  @action
  close() {
    this.inAppNotice.close()
  }

  @action
  replyAndClose() {
    this.inAppNotice.replyAndClose()
  }

  @action
  replyAndCloseWithEmoji(emoji) {
    this.inAppNotice.replyAndCloseWithEmoji(emoji)
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    InAppNoticeComponent: typeof InAppNoticeComponent
  }
}
